import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";

const FavContext = createContext(null);
const STORAGE_KEY = "rahhal.favorites.v1";

export function FavoritesProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
    catch (err) { console.warn("favorites read failed", err); return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const isFavorite = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback((dest) => {
    setIds((prev) => {
      if (prev.includes(dest.id)) {
        toast.info("♡");
        return prev.filter((x) => x !== dest.id);
      }
      toast.success("♥");
      return [...prev, dest.id];
    });
  }, []);

  return (
    <FavContext.Provider value={useMemo(() => ({ ids, isFavorite, toggle }), [ids, isFavorite, toggle])}>
      {children}
    </FavContext.Provider>
  );
}

export const useFavorites = () => useContext(FavContext);
